import * as React from "react";

function ShareIcon(props) {
  return (
    <span className="iiht-svg">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        {...props}
      >
        <g
          id="Group_12447"
          data-name="Group 12447"
          transform="translate(-653 -589)"
        >
          <rect
            id="Rectangle_4106"
            data-name="Rectangle 4106"
            width="24"
            height="24"
            transform="translate(653 589)"
            fill="none"
          />
          <path
            id="Shape"
            d="M10.968-20.262a.616.616,0,0,0-.256.056.683.683,0,0,0-.39.626v1.729a5.4,5.4,0,0,0-4.228,2.583,7.141,7.141,0,0,0-.984,2.587.677.677,0,0,0,.547.771.507.507,0,0,0,.092.007.662.662,0,0,0,.639-.578,5.808,5.808,0,0,1,.8-2.064A4.161,4.161,0,0,1,10.9-16.516h.013l.052,0a.665.665,0,0,0,.647-.681v-.8l1.814,1.819-1.816,1.594v-.651a.665.665,0,0,0-.646-.681.665.665,0,0,0-.647.681v2.1a.688.688,0,0,0,.374.616.594.594,0,0,0,.273.064.625.625,0,0,0,.411-.156l3.432-3.011a.7.7,0,0,0,.229-.5.7.7,0,0,0-.2-.517l-3.43-3.441A.62.62,0,0,0,10.968-20.262Zm-4.747.668H1.626A1.674,1.674,0,0,0,0-17.88V-6.712A1.673,1.673,0,0,0,1.626-5H11.864A1.674,1.674,0,0,0,13.49-6.714v-3.875a.668.668,0,0,0-.648-.681.665.665,0,0,0-.646.681V-6.71a.346.346,0,0,1-.336.354H1.624a.345.345,0,0,1-.335-.354V-17.878a.345.345,0,0,1,.335-.354h4.6a.665.665,0,0,0,.646-.681A.665.665,0,0,0,6.221-19.594Z"
            transform="translate(657 613.262)"
            fill="#fff"
          />
        </g>
        {/* fill="#3c4252" */}
      </svg>
    </span>
  );
}

export default ShareIcon;
